import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {Config} from "../../../common/config";
import {VoiceRecognitionService} from "../../../util/service/voice.recognition.service";
import {RouteUtil} from "../../../util/route.util";
import {ListResponse} from "../../../network/service/list.response";
import {DeviceService} from "../../../util/service/device.service";
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-dashboard-header',
  standalone: false,
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(-10px)'
        }),
        animate('300ms ease-out', style({
          opacity: 1,
          transform: 'translateY(0)'
        }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({
          opacity: 0,
          transform: 'translateY(-10px)'
        }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({opacity: 0}),
        animate('300ms ease-out', style({opacity: 1}))
      ])
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({transform: 'translateX(100%)'}),
        animate('300ms ease-out', style({transform: 'translateX(0)'}))
      ])
    ])
  ]
})
export class DashboardHeaderComponent extends BaseComponent implements OnInit, AfterViewChecked {
  @ViewChildren('lineMenuElement') lineMenuElements!: QueryList<ElementRef>;
  @ViewChild('column1') column1!: ElementRef;
  @ViewChild('column2') column2!: ElementRef;
  items = Array.from({length: 50}).map((_, i) => i + 1);
  isSyncingColumn1 = false;
  isSyncingColumn2 = false;
  closeMenu: boolean = true;
  subMenu: boolean = false;
  selectedIndex: number = -1;
  isRotated: boolean[] = [];
  isAdminPage: boolean = false;
  selectedLinkId: string | null = null;
  isLandingPage: boolean = false;
  menuCategories?: any = [];
  isScrolled: boolean = false;
  showHideImg: boolean = false;
  isDrawerOpen: boolean = false;
  isMobile: boolean = false;
  currentTheme: 'light' | 'dark' = 'light';
  protected readonly Config = Config;

  constructor(injector: Injector, private voiceRecognitionService: VoiceRecognitionService, private cdRef: ChangeDetectorRef, private deviceService: DeviceService) {
    super(injector);
    this.voiceRecognitionService.init();
    this.isMobile = this.deviceService.isMobile();
    this.isDrawerOpen = true;
    this.initializeTheme();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.router.events.subscribe((value: any) => {
      this.isLandingPage = this.router.url.endsWith('/Client');
    });
    this.isAdminPage = this.router.url.includes('/Dashboard');
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem('dashboard-theme');
    if (savedTheme) {
      this.currentTheme = savedTheme as 'light' | 'dark';
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.currentTheme = prefersDark ? 'dark' : 'light';
    }
    this.applyTheme();
  }

  toggleTheme() {
    this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    localStorage.setItem('dashboard-theme', this.currentTheme);
    this.applyTheme();
  }

  applyTheme() {
    const root = document.documentElement;
    root.classList.remove('theme-light', 'theme-dark');
    root.classList.add(`theme-${this.currentTheme}`);
  }

  override loadOnline() {
    super.loadOnline();
    this.getUserMenuLinks();
  }

  getUserMenuLinks() {
    this.serviceApi.getUserMenuLinks().subscribe((res: ListResponse<any>) => {
      this.menuCategories = [];
      let menuLinks = res.data;
      if (menuLinks && menuLinks.length > 0) {
        for (let i = 0; i < menuLinks.length; i++) {
          if (menuLinks[i].ParentId === null) {
            menuLinks[i].Status = false;
            this.menuCategories.push(menuLinks[i]);
          }
        }
        this.menuCategories.sort((menuCategory1: any, menuCategory2: any) => {
          return menuCategory1.Order > menuCategory2.Order ? 1 : -1;
        });
        for (let i = 0; i < this.menuCategories.length; i++) {
          this.menuCategories[i].MenuLinks = menuLinks.filter((menuLink: any) => {
            return menuLink.ParentId === this.menuCategories[i].PermissionId;
          }).sort((menuLink1: any, menuLink2: any) => {
            return menuLink1.Order > menuLink2.Order ? 1 : -1;
          });
        }
      }
    });
  }

  convertEnglishToPersian(query: string) {
    query = query.toLowerCase();
    query = query.replaceAll('q', 'ض');
    query = query.replaceAll('w', 'ص');
    query = query.replaceAll('e', 'ث');
    query = query.replaceAll('r', 'ق');
    query = query.replaceAll('t', 'ف');
    query = query.replaceAll('y', 'غ');
    query = query.replaceAll('u', 'ع');
    query = query.replaceAll('i', 'ه');
    query = query.replaceAll('o', 'خ');
    query = query.replaceAll('p', 'ح');
    query = query.replaceAll('[', 'ج');
    query = query.replaceAll(']', 'چ');
    query = query.replaceAll('a', 'ش');
    query = query.replaceAll('s', 'س');
    query = query.replaceAll('d', 'ی');
    query = query.replaceAll('f', 'ب');
    query = query.replaceAll('g', 'ل');
    query = query.replaceAll('h', 'ا');
    query = query.replaceAll('H', 'آ');
    query = query.replaceAll('j', 'ت');
    query = query.replaceAll('k', 'ن');
    query = query.replaceAll('l', 'م');
    query = query.replaceAll(';', 'ک');
    query = query.replaceAll('\'', 'گ');
    query = query.replaceAll('\\', 'پ');
    query = query.replaceAll('z', 'ظ');
    query = query.replaceAll('x', 'ط');
    query = query.replaceAll('c', 'ز');
    query = query.replaceAll('C', 'ژ');
    query = query.replaceAll('v', 'ر');
    query = query.replaceAll('b', 'ذ');
    query = query.replaceAll('n', 'د');
    query = query.replaceAll('m', 'پ');
    query = query.replaceAll(',', 'و');
    query = query.replaceAll('.', '.');
    query = query.replaceAll('/', '/');
    return query;
  }

  changeColor(index: number): void {
    if (this.selectedIndex === index) {
      this.selectedIndex = -1;
    } else {
      this.selectedIndex = index;
    }
    this.isRotated[index] = !this.isRotated[index];
    this.isDrawerOpen = true;
    this.showHideImg = false;
  }

  onSignOutClicked() {
    this.serviceApi.logout().subscribe((res: any) => {
      if (res === true) {
        Config.userInformation = null;
        this.router.navigate([RouteUtil.COMMON_MODULE]).then();
      }
    });
  }

  onMenuCategoryClicked(menuCategory: any, index: number) {
    this.menuCategories.forEach((category: any, i: any) => {
      if (i !== index) {
        category.Status = false;
        this.isRotated[i] = false;
      }
    });
    menuCategory.Status = !menuCategory.Status;
    this.isRotated[index] = !this.isRotated[index];
    this.selectedIndex = menuCategory.Status ? index : -1;
    const noActiveMenu = this.menuCategories.every((category: any) => !category.Status);
    this.selectedIndex = noActiveMenu ? -1 : index;
    this.closeMenu = true;
  }

  ngAfterViewChecked() {
    this.lineMenuElements.forEach((line) => {
      this.renderer.removeClass(line.nativeElement, 'animated');
    });
    if (this.selectedIndex !== -1 && this.lineMenuElements.toArray()[this.selectedIndex]) {
      const currentLine = this.lineMenuElements.toArray()[this.selectedIndex];
      if (currentLine) {
        this.renderer.addClass(currentLine.nativeElement, 'animated');
      }
    }
    this.cdRef.detectChanges();
  }

  onMenuLinkClicked(menuLink: any) {
    this.selectedLinkId = menuLink.PermissionId;
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, menuLink.EndPoint]).then();
  }

  onHomeClicked() {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.HOME_COMPONENT]).then();
    this.resetMenus();
    this.closeMenu = !this.closeMenu;
    this.showHideImg = !this.showHideImg;
  }

  openProfileClicked() {
    this.router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.ACCOUNT_COMPONENT]).then();
  }

  toggleDrawer() {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.HOME_COMPONENT]).then();
    this.isDrawerOpen = !this.isDrawerOpen;
    this.showHideImg = !this.showHideImg;
    this.resetMenus();
  }

  resetMenus() {
    this.menuCategories.forEach((menuCategory: any, index: any) => {
      menuCategory.Status = false;
      this.selectedLinkId = null;
      this.isRotated[index] = false;
    });
    this.selectedIndex = -1;
  }

  onScroll(event: Event) {
    const scrollTop = (event.target as HTMLElement).scrollTop;
    this.isScrolled = scrollTop > 0;
  }

  override ngAfterViewInit() {
    if (this.column1) {
      this.column1.nativeElement.addEventListener('scroll', this.syncScroll1.bind(this));
    }
    if (this.column2) {
      this.column2.nativeElement.addEventListener('scroll', this.syncScroll2.bind(this));
    }
  }

  syncScroll1() {
    if (!this.isSyncingColumn1) {
      this.isSyncingColumn2 = true;
      this.column2.nativeElement.scrollTop = this.column1.nativeElement.scrollTop;
    }
    this.isSyncingColumn1 = false;
  }

  syncScroll2() {
    if (!this.isSyncingColumn2) {
      this.isSyncingColumn1 = true;
      this.column1.nativeElement.scrollTop = this.column2.nativeElement.scrollTop;
    }
    this.isSyncingColumn2 = false;
  }

  noActionClicked() {
    this.showHideImg = true;
    this.menuCategories.forEach((menuCategory: any, index: any) => {
      menuCategory.Status = false;
    });
    this.closeMenu = false;
  }

  openDrawerClicked() {
    this.isDrawerOpen = true;
    this.showHideImg = false;
    this.closeMenu = true;
  }

  openSubMenu() {
    this.subMenu = !this.subMenu;
  }

  toggleMobileMenu() {
    this.isDrawerOpen = !this.isDrawerOpen;
    if (this.isDrawerOpen) {
      this.closeMenu = true;
      this.showHideImg = false;
    } else {
      this.closeMenu = true;
      this.showHideImg = false;
      this.resetMenus();
    }
  }

  toggleSidebar() {
    this.closeMenu = !this.closeMenu;
    this.showHideImg = !this.showHideImg;
    this.resetMenus();
    if (!this.closeMenu) {
      this.isDrawerOpen = false;
    } else {
      this.isDrawerOpen = true;
    }
  }

  onMobileMenuClose() {
    if (this.isMobile && this.isDrawerOpen) {
      this.isDrawerOpen = false;
    }
  }

  onKeyDown(event: KeyboardEvent, action: () => void) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  }
}
